"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExceptionMessageQuery = exports.ContentServiceQuery = void 0;
const graphql_request_1 = require("graphql-request");
exports.ContentServiceQuery = (0, graphql_request_1.gql) `
query Query($locale: String!, $content: String!) {
  staticContent(locale: $locale, content: $content) {
    locale
    url
  }
}
`;
exports.ExceptionMessageQuery = (0, graphql_request_1.gql) `
  query GetContent(
    $locale: String!, 
    $contentType: String!, 
    $subType: String!, 
    $loginStatus: ShowTo!, 
    $isHomePage: ContentBool!, 
    $max: Int!, 
    $treatmentCodes: [Int!],
    $min: Int!
  ) {
    content(
      locale: $locale
      contentType: $contentType
      subType: $subType
      loginStatus: $loginStatus
      isHomePage: $isHomePage
      max: $max
      treatmentCodes: $treatmentCodes
      min: $min
    ) {
      priority
      locale
      showTo
      title
      type
      messageText
      links {
        linkText
        href
        newWin
        external
      }
    }
  }
  `;
